import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, ConfirmationDialog } from '../../../common/components';
import CategoryIcon from '@mui/icons-material/Category';
import ConstructionTypesFilters from './components/ConstructionTypesFilters';
import ConstructionTypesDataTable from './components/ConstructionTypesDataTable';
import ConstructionTypesPagination from './components/ConstructionTypesPagination';
import ConstructionTypeDialog from './components/ConstructionTypeDialog';
import { useConstructionTypesTable } from './hooks/useConstructionTypesTable';

const ConstructionTypesTable = () => {
  const {
    data,
    plans,
    isLoading,
    totalPages,
    totalCount,
    page,
    rowsPerPage,
    searchTerm,
    selectedPlan,
    dialogOpen,
    editMode,
    selectedConstructionType,
    deleteConfirmOpen,
    entityToDelete,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handlePlanChange,
    handleEdit,
    handleSave,
    handleDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useConstructionTypesTable();

  if (isLoading) { return <LoadingSkeleton />; }

  return (
    <Box>
      <FormTitleBox
        title="Obra | Seguimiento | Tipos de construcción"
        showButton={true}
        buttonText="Agregar Tipo"
        buttonIcon={CategoryIcon}
        onButtonClick={handleOpenDialog}
      />

      <ConstructionTypesFilters
        searchTerm={searchTerm}
        selectedPlan={selectedPlan}
        plans={plans}
        onSearchChange={handleSearch}
        onPlanChange={handlePlanChange}
      />

      <ConstructionTypesDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        LoadingComponent={LoadingSkeleton}
      />

      <ConstructionTypesPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <ConstructionTypeDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        constructionType={selectedConstructionType}
        plans={plans}
        onInputChange={handleInputChange}
        onSave={handleSave}
      />

      <ConfirmationDialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        entityName="tipo de construcción"
        message={`¿Está seguro que quiere eliminar el tipo de construcción "${
          entityToDelete?.name || ''
        }"?`}
      />
    </Box>
  );
};

export default ConstructionTypesTable;
